import { Box, LinearProgress, Typography } from "@mui/material";

/**
 * Route paths for the task module.
 * Single source of truth — reuse these instead of hard-coding `/tasks...` strings.
 */
export const TASK_ROUTES = {
  root: "/tasks",
  progress: "/tasks/:id/progress",
} as const;

export const getTaskTableColumns = ({ isProjectPage = false } = {}) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.5, sortable: false },
    { field: "name", headerName: "Task Name", flex: 1.5, sortable: true },
    { field: "assignedTo", headerName: "Assignee", flex: 1.5, sortable: false },
    { field: "projectId", headerName: "Project", flex: 1, sortable: false },
    { field: "quantity", headerName: "Quantity", flex: 1, sortable: true },
    {
      field: "progress",
      headerName: "Progress",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const { row } = params;
        const percentage = row.taskQuantity ? Math.min((row.taskProgressQuantity / row.taskQuantity) * 100, 100) : 0;

        let progressColor;
        if (percentage > 0 && percentage < 100) progressColor = "#ffa500";
        else if (percentage === 100) progressColor = "#4caf50";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <Box sx={{ position: "relative", flexGrow: 1 }}>
              <LinearProgress
                variant="determinate"
                value={percentage}
                sx={{
                  height: 8,
                  borderRadius: 5,
                  backgroundColor: percentage === 0 ? "#f44336" : "#e0e0e0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: percentage === 0 ? "#f44336" : progressColor,
                  },
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  position: "absolute",
                  top: -18,
                  right: 0,
                  fontWeight: 500,
                  fontSize: "0.65rem",
                }}
              >
                {row?.taskProgressQuantity}/{row?.taskQuantity}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
  ];

  return isProjectPage ? headers.filter((col) => col.field !== "projectId") : headers;
};
